import { render, staticRenderFns } from "./TheForm.vue?vue&type=template&id=2b7ebac8&scoped=true"
import script from "./TheForm.vue?vue&type=script&lang=js"
export * from "./TheForm.vue?vue&type=script&lang=js"
import style0 from "./TheForm.vue?vue&type=style&index=0&id=2b7ebac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7ebac8",
  null
  
)

export default component.exports